import styled from 'styled-components';

const WithStyle = (ComponentName) => styled(ComponentName)`
  margin-top: 1rem;
`;

export { WithStyle };
